module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"heading":"Steuersatz Einstellungen","vat_details":"Steuersätze","regular_vat_details":"Reguläre Steuersätze","reduced_vat_details":"Reduzierte Steuersätze"},"en":{"heading":"VAT settings","vat_details":"VAT rates","regular_vat_details":"Regular VAT rates","reduced_vat_details":"Reduced VAT rates"}}')
  delete Component.options._Ctor
}
